// src/components/AboutMe.js
import React from 'react';

const AboutMe = () => {
  return (
    <section>
      <h2>About Me</h2>
      <img src="/path/to/photo.jpg" alt="Developer" />
      <p>Short bio about the developer.</p>
    </section>
  );
};

export default AboutMe;